import { CompanyEmployeeWithSubsidyAmount } from '@app/@graphql';
import { Observable } from 'rxjs';


export interface GroupTableData
{
    id,
    name,
    amount,
    dailyMaximum,
    quotaPeriodStart,
    quotaPeriodEnd,
}

export abstract class GroupsData {
    abstract getAllGroupsTableData(): Observable<GroupTableData[]>;
}